import { Component, Inject, OnInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { SocialHelperAdditionalSettings } from '@app/store/models/social-helper-additional-settings.interface';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';
import { environment } from 'src/environments/environment';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { QrGeneratorNavigatorCategories } from 'shared-library';
import { QrGeneratorNavigatorSteps } from '@app/store/enums/qr-generator-navigator-steps.enum';
import { QrGeneratorAudio } from '@app/store/models/qr-generator-audio.interface';
import { QrGeneratorNavigator } from '@app/store/models/qr-generator-navigator.interface';
import { APP_CONFIG } from '@app/modules/core/config/config';
import { IAppConfig } from '@app/store/models/config.interface';

@Component({
  selector: 'app-shared-qr-preview-mp3',
  templateUrl: './shared-qr-preview-mp3.component.html',
  styleUrls: ['./shared-qr-preview-mp3.component.scss']
})
export class SharedQrPreviewMp3Component implements OnInit {

  create_mode = !window.location.href.includes("edit")

  audio: QrGeneratorAudio
  supported_browser = !!this.qrGeneratorService.initiateAudioPlayer()

  session_info: SessionInfo
  data: QrGeneratorNavigator
  private subscriptions: Subscription[] = []

  social_data = this.qrGeneratorService.initSocialHelper()
  event_additional_settings_obs: Subject<SocialHelperAdditionalSettings> = new Subject<SocialHelperAdditionalSettings>()

  constructor(
    private coreService: CoreService,
    public functions: FunctionsService,
    private qrGeneratorService: UserQrGeneratorService,
    @Inject(APP_CONFIG) public readonly config: IAppConfig
  ) {

    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => {
      this.session_info = si

      let d: QrGeneratorNavigator
      if (this.create_mode) {
        d = this.session_info.qr_generating.drafts.find(d => d.selected_category == QrGeneratorNavigatorCategories.MP3)
      } else {
        d = this.session_info.qr_generating.updating
      }

      if (d) {

        if (d.mp3_data) {
          this.event_additional_settings_obs.next({
            text_color: d.mp3_data.colors.text_color,
            tooltip: ""
          })
          this.functions.initializeTooltip()
        }
        if (d.active_step === QrGeneratorNavigatorSteps.START) {
          // show demo data instead
          this.data = JSON.parse(JSON.stringify(d))
          this.data.mp3_data.headings.main = "BRANDQRCODES"
          this.data.mp3_data.headings.meta = "Text to speech"
          this.data.mp3_data.mp3.url = `${environment.files_url}assets/resources/samples/voices/audio.mp3`
          this.data.mp3_data.cta.show = true
          this.data.mp3_data.cta.title = "LEARN MORE"
          this.data.mp3_data.cta.url = "https://brandqrcodes.com"
          this.data.mp3_data.website = "brandqrcodes.com"
          this.data.mp3_data.mp3.downloadable = true
          this.data.mp3_data.share_on = true
          this.data.mp3_data.colors.primary_color = "#101820FF"
          this.data.mp3_data.colors.secondary_color = "#d92027"
          this.audio = this.qrGeneratorService.fillAudioPlayer(this.data.mp3_data.mp3.url, this.audio)
          return
        }
        this.data = d
        this.audio = this.qrGeneratorService.fillAudioPlayer(this.data.mp3_data.mp3.url, this.audio)
      }
    }));
  }

  ngOnInit(): void {
    this.functions.initializeTooltip()
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

  playSound() {
    if (this.audio.playing) {
      this.audio.playing = false
      this.audio.player.pause()
      return
    }
    this.audio.playing = true
    this.audio.player.play()
  }

  async downloadAudio() {
    if (this.audio.downloading) return
    this.audio.downloading = true
    let link = document.createElement('a')
    link.target = "_blank"
    link.href = this.data.mp3_data.mp3.url
    link.download = (this.data.mp3_data.mp3.name || "untitled_audio") + '.mp3'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    this.audio.downloading = false
  }

}
